import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const archiveUnitActivationById = async (id: number | null): Promise<boolean> =>
  axios.get(`/UnitActivation/archiveunitactivationrequestbyid?requestId=${id}`).then((res) => res.data?.result)

type Props = {
  id: number | null
}

export const useArchiveUnitActivation = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['archiveUnitActivationById'],
    mutationFn: ({ id }: Props) => archiveUnitActivationById(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Archived.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to archive, please try again.')
      }
    },
    throwOnError: false
  })
